import React from 'react';
/* eslint-disable import/no-anonymous-default-export */
import NumberWithSuffix from '../../NumberWithSuffix';
import CountryField from '../../CountryField';
import MobilityIcon from '../../../images/mobility.svg';
import InvestmentIcon from '../../../images/investment.svg';
import QualityIcon from '../../../images/quality.svg';
import { TooltipComponent } from '../../TooltipComponent';
export const getDefaultTooltip = () => {
	const list = [
		'The overall level of socio-economic development',
		'The cost of living',
		'The protection of personal freedoms',
		'The state of environmental sustainability',
		'The level of “happiness” of citizens',
		'The acceptance of migrants',
	];
	const item = (text, idx, arr) =>
		`<li class="${idx < arr.length - 1 ? 'mb-2' : ''} flex flex-row">
			<span style="letter-spacing: -1.75px;" class="font-bold mr-2">${idx + 1}.</span>
			<span class="text-mono text-mono--grey">
				${text}
			</span>
		</li>`;
	const wrapElements = (els) => `<ul>${els}</ul>`;
	return wrapElements(list.map(item).join(''));
};
export const CommonIndexes = [
	{
		Header: (
			<div className="columnheader__field">
				<div>
					<div className="common-idx__label --inline text-mono text-mono--grey">
						Enhanced <br />
						mobility index
					</div>
					<TooltipComponent id="mobilty_rank-tooltip">
						The enhanced mobility index carries the most weight
						(50%) and takes into account the travel benefits for the
						holder, alongside the desirability of the country, based
						on its quality of life.
					</TooltipComponent>
				</div>
				<img className="columnheader__icon" src={MobilityIcon} />
			</div>
		),
		Cell: ({ value }) => {
			if (!value) return '-';
			return <NumberWithSuffix number={value} />;
		},
		title: 'Enhanced mobility index',
		accessor: 'mobilty_rank',
		minWidth: 110,
		mobileMinWidth: 30,
	},
	{
		Header: (
			<div className="columnheader__field">
				<div>
					<div className="common-idx__label --inline text-mono text-mono--grey">
						Investment <br />
						index
					</div>
					<TooltipComponent id="invest_rank-tooltip">
						The investment index is worth 25% of the overall
						calculation. This index is a general assessment of the
						economy as an option for investment and other business
						decisions. Prosperous nations that have dynamic
						economies are favored and personal taxation is also
						taken into account.
					</TooltipComponent>
				</div>
				<img className="columnheader__icon" src={InvestmentIcon} />
			</div>
		),
		Cell: ({ value }) => {
			if (!value) return '-';
			return <NumberWithSuffix number={value} />;
		},
		accessor: 'invest_rank',
		title: 'Investment index',
		minWidth: 110,
		mobileMinWidth: 30,
	},
	{
		Header: (
			<div className="columnheader__field">
				<div>
					<div className="common-idx__label --inline text-mono text-mono--grey">
						Quality of <br />
						living index
					</div>
					<TooltipComponent id="eqol_rank-tooltip">
						The Quality of living index is worth 25% of the overall
						calculation. This index covers six main components
						relating to the quality of life - sustainable
						development, cost of living, level of happiness,
						personal freedoms, environmental performance, and
						migrants’ acceptance.
					</TooltipComponent>
				</div>
				<img className="columnheader__icon" src={QualityIcon} />
			</div>
		),
		Cell: ({ value }) => {
			if (!value) return '-';
			return <NumberWithSuffix number={value} />;
		},
		accessor: 'eqol_rank',
		title: 'Quality of living index',
		minWidth: 110,
		mobileMinWidth: 30,
	},
];

export const NumeralIndex = (props = {}) => {
	return {
		Header: () => (
			<div className="desktop-only --inline text-mono text-mono--grey">
				Global <br />
				passport <br />
				index
			</div>
		),
		Cell: ({ value, column: { title } }) => {
			if (!value) return '-';
			return (
				<NumberWithSuffix
					number={value}
					title="Global passport index"
					type="accent"
				/>
			);
		},
		accessor: 'global_passport_rank',
		maxWidth: 100,
		...props,
	};
};

export const CountryName = (props = {}) => {
	const { truncate = true } = props;
	return {
		Header: () => (
			<div className="desktop-only --inline text-mono text-mono--grey">
				Country
			</div>
		),
		accessor: 'iso2c',
		width: '100%',
		Cell: ({ value }) => {
			if (!value) return '-';
			return (
				<CountryField
					code={value}
					useShortFormOnMobile={true}
					truncate={truncate}
					title="Country"
				/>
			);
		},
	};
};

export const BaseText = (props) => {
	const {
		Header,
		HeaderName,
		HeaderTooltip,
		HeaderTooltipType = 'string',
		isHeaderDesktopOnly,
	} = props;
	let headerClassName = ['text-mono', 'text-mono--grey'];
	if (isHeaderDesktopOnly) headerClassName.push('desktop-only');
	return {
		accessor: 'investment',
		maxWidth: 56,
		Cell: ({ value, column: { title } }) => {
			if (!value) return '-';
			return <div className="font-bold">{value}</div>;
		},
		...props,
		Header: (
			<div className={headerClassName.join(' ')}>
				{HeaderName}
				{Header}
				{HeaderTooltip && (
					<TooltipComponent
						id={props.accessor}
						type={HeaderTooltipType}
					>
						{HeaderTooltip}
					</TooltipComponent>
				)}
			</div>
		),
	};
};
